module.exports = __webpack_public_path__ + "static/media/auth.13df932c.svg";